import React, { useEffect, useState, useRef } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import CloseIcon from "assets/svgIcons/CloseIcon";
import {
    CurrentPageContainer,
    HeadingWrapper,
    Wrapper,
    BodyWrapper,
    DetailSideTab,
    Card,
    NotificationTabsContainer,
    CardWrapper,
} from "pages/Pace/Current/CurrentPageStyled";
import { CircleBtn } from "assets/css/globle";
import {
    Chart,
    ChartTitle,
    ChartXAxis,
    ChartXAxisItem,
    ChartYAxis,
    ChartYAxisItem,
    ChartSeries,
    ChartSeriesItem,
    ChartLegend,
    ChartPane,
    ChartPanes,
    ChartTooltip,
} from "@progress/kendo-react-charts";
import "hammerjs";
import "@progress/kendo-theme-default/dist/all.css";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import moment from "moment";
import _ from "lodash";
import { Modal } from "@mui/material";
import { CarDetails } from "commonComponents/CarDetails";
import { MsgToSelectedCarsCmp } from "commonComponents/SideNav/subSectionNav/Map/commonFunctionalities/MsgToSelectedCars";
import { useHookstate } from "@hookstate/core";
import {
    FLEET_GLOBAL_STATES,
    MAP_GLOBAL_STATES,
    MESSAGE_FLEET_GLOBAL_STATES,
    SIDENAV_GLOBAL_STATE,
    COMMON_COMPONENTS_STATES,
    UPDATED_CAR_DATA_STATE,
    SITEID_GLOBAL_STATE
} from "globalStore/globalStore";
import { useNavigate } from "react-router-dom";
import { API_STATUSES } from "redux/_helpers/statuses";
import { Loader } from "commonComponents/Loader/Loader";
import { isValidLocation } from "_helperFunctions/isValidLocation";
import { deviceType } from "_helperFunctions/deviceType";
import { useCallback } from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { uuid } from "_helperFunctions/uuid";
import {
    featureKey,
    staleTimeInMinutes,
    holeLocation,
    carType,
    memberCarTrackingLevel,
    reasonForReportString,
    reportReasons,
    PACE_STATUS_NORMAL,
    PACE_STATUS_WARNING,
    PACE_STATUS_CRITICAL,
    PACE_STATUS_NORMAL_STR,
    PACE_STATUS_WARNING_STR,
    PACE_STATUS_CRITICAL_STR
} from "constant";

const carDetailStyle = {
    position: "absolute",
    top: "0%",
    left: "unset",
    right: "0",
    bottom: "0",
    maxWidth: 420,
    width: "100%",
    bgcolor: "background.paper",
};

const msgToCarsStyle = {
    position: "absolute", //map > car > msg
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "320px",
    bgcolor: "#ffffff",
    zIndex: 1,
};

const CurrentPage = React.memo(() => {
    const { t } = useTranslation();

    let cars = null;

    const detailW = useRef(null);
    const containerW = useRef(null);
    const divRef = useRef(null);

    const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

    const {
        siteSettingsData,
        getCarsStatus,
        getMessagesFromCarsData,
        getFaultsData,
        getSiteAreasState,
        getHoleAreasState,
        updateCarTypeData,
        getCarPathActionZone,
        getSingleCarTrackState,
        getSingleCarTrackStatus,
    } = useSelector((state) => state.commonReducers) || [];

    const { subNavDataState, sideDrawerActiveTabState } = useHookstate(SIDENAV_GLOBAL_STATE);

    const { isLoading } = useHookstate(MESSAGE_FLEET_GLOBAL_STATES);
    const { showMessageBoxForSingleCar } = useHookstate(MAP_GLOBAL_STATES);
    const {
        taggedCarsSaverGlobalState,
        taggedCarsDisplayerGlobalState,
        paceFindCar,
        highlightTagCar,
        showTaggedCarArray,
        tagCarNumber,
        paceLoading
    } = useHookstate(MAP_GLOBAL_STATES);

    const { updatedCarData } = useHookstate(UPDATED_CAR_DATA_STATE);

    const allCarsData = updatedCarData.get()?.length > 0 ? JSON.parse(updatedCarData.get()) : [];

    const { setMsgToSingleCar, storeFleetTagCarData, gpsCardIdStateData } = useHookstate(FLEET_GLOBAL_STATES);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { findCars } = useHookstate(COMMON_COMPONENTS_STATES);

    const [chartReadyToDraw, setChartReadyToDraw] = useState(false);
    const [detailTab, setDetailTab] = useState(false);
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const [tabIndex, setTabIndex] = React.useState(0);
    const [tempIndex, setTempIndex] = React.useState([]);
    const [historyTempIndex, setHistoryTempIndex] = React.useState([]);
    const [activeHistory, setActiveHistory] = useState({});
    const [value, setValue] = React.useState("1");
    const [geoFence, setGeoFence] = React.useState(null);
    const [siteSettingsCourses, setSiteSettingsCourses] = React.useState([]);
    const [courseCarsInUseArray, setCourseCarsInUseArray] = React.useState([]);
    const [featuresResortEdition, setFeaturesResortEdition] = React.useState(false);
    const [chartData, setChartData] = React.useState([]);
    const [noCarsList, setNoCarsList] = React.useState([]);
    const [detailTabData, setDetailTabData] = React.useState({});
    const [criticalPlotBand, setCriticalPlotBand] = React.useState(null);
    const [warningPlotBand, setWarningPlotBand] = React.useState(null);
    const [carDetailsTab, setCarDetailsTab] = useState([]);
    const [msgInput, setMsgInput] = useState("");
    const [historyCarNo, setHistoryCarNo] = useState([]);
    const [chartHoleCountData, setChartHoleCountData] = useState(null);
    const [currentCarProperty, setCurrentCarPorperty] = useState("");
    const [refreshChart, setRefreshChart] = useState(true);
    const [disabledStatus, setDisabledStatus] = useState(false);
    const [prevChartData, setPrevChartData] = useState();
    const [filteredCourse, setFilteredCourse] = useState([]);
    const [getChartDimensions, setGetChartDimensions] = useState({ chartWidth: 0, chartHeight: 0 });

    const car = detailTabData.car;

    const getPaceHistory = useCallback((courseNumber) => {
        if (getSingleCarTrackStatus === "success") {
            cars = getCarsInUseByGolfers();
            setFilteredCourse(getCoursesPlayingList());

            let tempcheckArrayUseIn = JSON.parse(JSON.stringify(chartData));
            let tempCheck = JSON.parse(JSON.stringify(getSingleCarTrackState));

            let courseIndex = _.findIndex(chartData, function (tCourse) {
                return tCourse.Number === courseNumber;
            });

            if (tempCheck && tempCheck.length > 0) {
                tempCheck.sort(function (a, b) {
                    var compareResult = 0;
                    var firstDate = moment(a?.LastLocationUpdateInUtc);
                    var secondDate = moment(b?.LastLocationUpdateInUtc);
                    compareResult = compare(firstDate, secondDate);
                    return -compareResult;
                });

                let j = 0;
                let tempCarHistory = [];

                do {
                    if (
                        tempCheck[j] !== undefined &&
                        tempCheck[j]?.CarType === carType.member &&
                        !canShowMemberCar(tempCheck[j])
                    )
                        continue;

                    tempCarHistory.push(tempCheck[j]);
                    j += 1;

                    if (tempCheck[j] === undefined) {
                        break;
                    }
                } while (tempCheck[j].Course !== 0);

                let tempHistoryData = conformHistoryCarData(
                    tempCarHistory,
                    courseCarsInUseArray[courseIndex].Number
                );

                if (tempHistoryData.length > 0) {
                    const result = tempHistoryData.filter(
                        (thing, index, self) =>
                            index ===
                            self.findIndex(
                                (t) => t?.hole === thing.hole && t?.pace === thing.pace
                            )
                    );

                    tempcheckArrayUseIn[courseIndex].carData = result;
                    setChartData(tempcheckArrayUseIn);
                    setRefreshChart(true);
                    setTimeout(() => setRefreshChart(false), 2000);
                }

            } else {
                tempcheckArrayUseIn[courseIndex].carData = conformCarData(
                    cars,
                    courseCarsInUseArray[courseIndex].Number
                );

                setChartData(tempcheckArrayUseIn);
            }
        }
    },
        [getSingleCarTrackState]
    );

    const tempGetPaceHistory = useCallback((carCourseNo) => {
        if (getSingleCarTrackState) {
            cars = getCarsInUseByGolfers();
            setFilteredCourse(getCoursesPlayingList());

            let tempcheckArrayUseIn = JSON.parse(JSON.stringify(chartData));
            let tempCheck = JSON.parse(JSON.stringify(getSingleCarTrackState));

            let courseIndex = _.findIndex(chartData, function (tCourse) {
                return tCourse.Number === carCourseNo;
            });

            if (tempCheck && tempCheck.length > 0) {
                tempCheck.sort(function (a, b) {
                    var compareResult = 0;
                    var firstDate = moment(a?.LastLocationUpdateInUtc);
                    var secondDate = moment(b?.LastLocationUpdateInUtc);
                    compareResult = compare(firstDate, secondDate);
                    return -compareResult;
                });

                let j = 0;
                let tempCarHistory = [];

                do {
                    if (
                        tempCheck[j] !== undefined &&
                        tempCheck[j]?.CarType === carType.member &&
                        !canShowMemberCar(tempCheck[j])
                    )
                        continue;

                    tempCarHistory.push(tempCheck[j]);
                    j += 1;

                    if (tempCheck[j] === undefined) {
                        break;
                    }
                } while (tempCheck[j].Course !== 0);

                let tempHistoryData = conformHistoryCarData(
                    tempCarHistory,

                    carCourseNo
                );

                if (tempHistoryData.length > 0) {
                    const result = tempHistoryData.filter(
                        (thing, index, self) =>
                            index ===
                            self.findIndex(
                                (t) => t?.hole === thing.hole && t?.pace === thing.pace
                            )
                    );

                    tempcheckArrayUseIn[courseIndex].carData = result;
                    setChartData(tempcheckArrayUseIn);
                    setRefreshChart(true);
                    setTimeout(() => setRefreshChart(false), 2000);
                }

            }
        }
    },
        [getSingleCarTrackState]
    );

    useEffect(() => {
        if(Object.keys(siteSettingsData).length > 0) {
            if(siteSettingsData?.Features?.indexOf(featureKey.golf) <= 0) {
                navigate("/dashboard", { replace: true });
            }
        }
    }, [siteId.get(), siteSettingsData]);

    useEffect(() => {
        if (detailW.current?.clientWidth === null || containerW.current?.clientWidth === null) {
            return;
        }
    }, []);

    useEffect(() => {
        setChartData([]);
    }, [siteSettingsData, siteId.get()]);

    useEffect(() => {
        paceLoading.set(true);

        dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
        dispatch(COMMON_SERVICES.getSiteAreasServices(siteId.get()));
        dispatch(COMMON_SERVICES.getHoleAreasServices(siteId.get()));
        dispatch(COMMON_SERVICES.getActionZoneServices(siteId.get()));
        setRefreshChart(true);
        setTimeout(() => setRefreshChart(false), 2000);
    }, [siteId.get()]);

    useEffect(() => {
        setDetailTab(false);
        setNoCarsList([]);
        getData();
        setRefreshChart(true);
        setTimeout(() => setRefreshChart(false), 2000);
    }, [siteId.get()]);

    useEffect(() => {
        if (Object.keys(siteSettingsData).length > 0) {
            getData();
            setRefreshChart(true);
            setTimeout(() => setRefreshChart(false), 2000);
        }
    }, [siteSettingsData, window.innerWidth]);

    useEffect(() => {
        let interval = setInterval(() => {
            dispatch(COMMON_SERVICES.getCarServices(false, siteId.get()));
        }, 10000);

        return () => {
            clearInterval(interval);
        };
    }, []);

    useEffect(() => {
        if (refreshChart)
            setRefreshChart(false);
    }, [getMessagesFromCarsData, getFaultsData]);

    useEffect(() => {
        getData();
        setRefreshChart(true);
        setTimeout(() => setRefreshChart(false), 2000);
    }, [updateCarTypeData, siteId.get()]);

    useEffect(() => {
        setSiteSettingsCoursesArray();
    }, []);

    useEffect(() => {
        storeCurrentGeoFence();
    }, [getCarPathActionZone]);

    useEffect(() => {
        if (Object.keys(siteSettingsData).length > 0) {
            setFeaturesResortEdition(siteSettingsData?.Features.indexOf(featureKey.resortEdition) >= 0);
            getData();
            setCriticalPlotBand(siteSettingsData && siteSettingsData?.CriticalThreshold);
            setWarningPlotBand(siteSettingsData && siteSettingsData?.WarningThreshold);
            setRefreshChart(true);
            setTimeout(() => setRefreshChart(false), 2000);
        }
    }, [siteSettingsData]);

    useEffect(() => {
        if (allCarsData?.length !== 0) {
            let carData = allCarsData;
            if (carData && Array.isArray(carData) && carData.length !== 0) {
                const carObjData = carData.filter(
                    (item) => item?.Car?.GpsiCarId === car?.Car?.GpsiCarId
                );
                setCurrentCarPorperty(carObjData[0]);
            }

            setRefreshChart(true);
            setTimeout(() => setRefreshChart(false), 2000);
        }
    }, [allCarsData]);

    useEffect(() => {
        if (getSingleCarTrackState && getSingleCarTrackState.length > 0) {
            setDisabledStatus(false);
            tempShowPaceHistory(car);
        }
    }, [getSingleCarTrackState]);

    useEffect(() => {
        if (getCarsStatus === API_STATUSES.SUCCESS) {
            getData();
            setRefreshChart(true);
            setTimeout(() => setRefreshChart(false), 2000);
        }
    }, [getCarsStatus === API_STATUSES.SUCCESS]);

    useEffect(() => {
        let check = chartData.length !== 0 ? chartData[0]?.HoleCount : null;
        setChartHoleCountData(check + 1);
    }, [chartData]);

    useEffect(() => {
        const localData = JSON.parse(localStorage.getItem("taggedCarsData"));
        if (localData) {
            taggedCarsSaverGlobalState.set(localData.tagCarsDataMap);
            showTaggedCarArray.set(localData.tagCarsDataFilters);
            taggedCarsDisplayerGlobalState.set(
                localData.taggedCarsDisplayerGlobalState
            );
        }
    }, []);
    useEffect(() => {
        const handleResize = () => {
            if (divRef.current) {
                let contentWidth = divRef.current.offsetWidth - 80; // 80 is a "fudge factor" to include chart margins, padding, and (if) scrollbar width
                let contentHeight = divRef.current.offsetHeight;

                if (contentWidth > 1 && contentHeight > 1) {
                    setChartReadyToDraw(true);
                }

                let chartDimensions = {};
                let widthMin = 850; // chart starts getting unusable when smaller than these dimensions
                let heightMin = 400;
                let widthMax = 2560; // rounded down from common screen size (1360x768), much bigger than this and chart looks odd
                let heightMax = 750;

                //adjust max if large screen and multiple courses to try to avoid the need to scroll
                if (filteredCourse.length > 1 && contentWidth > 1500) {
                    if (filteredCourse.length > 2) {
                        widthMax = contentWidth / 2;
                        heightMax = contentHeight / 2 - 25;
                    } else {
                        widthMax = contentWidth / 2;
                    }
                }

                //check for max
                chartDimensions.chartWidth = contentWidth < widthMax ? contentWidth : widthMax;
                chartDimensions.chartHeight = contentHeight < heightMax ? contentHeight : heightMax;

                //check for minimum
                chartDimensions.chartWidth = chartDimensions.chartWidth < widthMin ? widthMin : chartDimensions.chartWidth;
                chartDimensions.chartHeight = chartDimensions.chartHeight < heightMin ? heightMin : chartDimensions.chartHeight;

                setGetChartDimensions(chartDimensions);
            }
        };

        handleResize();

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleChange = (newValue) => {
        setValue(newValue);
    };

    function getCoursesPlayingList() {
        var filteredCarsArray = _.filter(getCarsInUseByGolfers(), function (car) {
            return (
                car?.Car?.LocationReasonForReport !==
                reportReasons.REASON_FOR_REPORT_UNDEFINED &&
                car?.Car?.LocationReasonForReport !==
                reportReasons.REASON_FOR_REPORT_VCC_FADE &&
                (car?.Car?.LocationReasonForReport !==
                    reportReasons.REASON_FOR_REPORT_APN_FADE ||
                    car?.Car?.DevType === deviceType.VDU3 ||
                    car?.Car?.DevType === deviceType.VDU4)
            );
        });
        return _.uniq(filteredCarsArray, function (car) {
            return car?.Car?.Course;
        });
    }

    function setCoursesInUseArray() {
        let localCourseCarsInUseArray = [];

        for (let i = 0; i < siteSettingsData?.Courses?.length; i++) {
            let tempCourse = {};
            tempCourse.siteId = siteSettingsData?.Id;
            tempCourse.carData = null;
            tempCourse.dataForChart = {};
            tempCourse.HoleCount = siteSettingsData?.Courses[i].HoleCount;
            tempCourse.Name = siteSettingsData?.Courses[i].Name;
            tempCourse.Number = siteSettingsData?.Courses[i].Number;
            tempCourse.clickedData = {};
            tempCourse.showingCarHistory = false;

            localCourseCarsInUseArray.push(tempCourse);
        }

        setCourseCarsInUseArray(localCourseCarsInUseArray);

        return localCourseCarsInUseArray;
    }

    function setSiteSettingsCoursesArray() {
        let localSiteSettingsCourses = [];

        for (let i = 0; i < siteSettingsData?.Courses?.length; i++) {
            let tempCourse = {};

            tempCourse.HoleCount = siteSettingsData?.Courses[i].HoleCount;
            tempCourse.Id = siteSettingsData?.Courses[i].Id;
            tempCourse.Name = siteSettingsData?.Courses[i].Name;
            tempCourse.Number = siteSettingsData?.Courses[i].Number;
            tempCourse.showButton = false;
            tempCourse.showLoading = false;
            tempCourse.courseInPlay = false;
            tempCourse.siteId = siteSettingsData?.Id;

            localSiteSettingsCourses.push(tempCourse);
        }

        setSiteSettingsCourses(localSiteSettingsCourses);

        return localSiteSettingsCourses;
    }

    function isMemberCar(car) {
        return car?.Car?.CarType === carType?.member;
    }

    const handleCarDetailClose = () => {
        setOpen(false);
        setMsgToSingleCar.set(null);
    };

    function paceString() {
        let result = "";
        if (detailTabData?.car) {
            if (detailTabData?.car?.Car?.Pace > 0)
                result = detailTabData?.car?.Car?.Pace.toString() + t("min_ahead");
            else if (detailTabData?.car?.Car?.Pace < 0)
                result = (-detailTabData?.car?.Car?.Pace).toString() + t("min_behind");
            else result = t("on_pace");
            if (detailTabData?.car?.Car?.HolesPlayed > 0)
                result =
                    result +
                    t("through") +
                    detailTabData?.car?.Car?.HolesPlayed.toString() +
                    t("Hole") +
                    (detailTabData?.car?.Car?.HolesPlayed > 1 ? "s" : "");
        }
        return result;
    }

    function paceStatusBackColor(x) {
        if (x === PACE_STATUS_NORMAL || x === PACE_STATUS_NORMAL_STR)
            return "#0E6D38"; // was 'green', #0E6D38 is from the jWin8 styles
        else if (x === PACE_STATUS_WARNING || x === PACE_STATUS_WARNING_STR)
            return "#FDD017"; // 'yellow';
        else if (x === PACE_STATUS_CRITICAL || x === PACE_STATUS_CRITICAL_STR)
            return "red";
        else return "gray";
    }

    function paceStatusString(x) {
        if (x === PACE_STATUS_NORMAL || x === PACE_STATUS_NORMAL_STR)
            return "Normal";
        else if (x === PACE_STATUS_WARNING || x === PACE_STATUS_WARNING_STR)
            return "Warning";
        else if (x === PACE_STATUS_CRITICAL || x === PACE_STATUS_CRITICAL_STR)
            return "Critical";
        else return "Unknown"; // "Unknown Pace Status";
    }

    function getPaceString(pace, holesPlayed) {
        // If not a golfer type of car then just return an empty string
        var result = "";
        // if (type === carType.normal || type === carType.handicap) {
        if (pace > 0) result = pace.toString() + " " + t("min_ahead") + " ";
        else if (pace < 0)
            result = (-pace).toString() + " " + t("min_behind") + " ";
        else result = t("on_pace") + " ";
        if (holesPlayed > 0)
            result = result + t("through") + " " + holesPlayed.toString();
        return result;
    }

    function compare(a, b) {
        return a > b ? 1 : a < b ? -1 : 0;
    }

    function isCarInUse(car, includeNotPlaying, includeNoComm, includeCharging) {
        // If marked out-of-service, never count as in use
        if (car?.Car?.CarType === carType.outOfService) return false;

        // Must have reported position within last XX minutes to count
        let ageInMinutes = moment().diff(
            moment.utc(car?.Car?.LastLocationUpdateInUtc),
            "minutes"
        ); // JFG: I don't think .utc is necessary here
        if (ageInMinutes > staleTimeInMinutes) return false;

        if (
            car?.Car?.DevType !== deviceType.FT ||
            car?.Car?.DevType !== deviceType.WT
        ) {
            // For all cars, must be off charge and have a valid lat/long
            if (
                car?.Car?.IsCharging ||
                !isValidLocation(car?.Car?.Latitude, car?.Car?.Longitude)
            )
                return false;

            if (featuresResortEdition) {
                // For regular and special needs car, must have a guest name and/or suite assigned to count as "in use"
                if (
                    car?.Car?.CarType !== carType?.marshal &&
                    car?.Car?.CarType !== carType?.bevcart
                )
                    if (!car?.Car?.PlayerName1 && !car?.Car?.PlayerName2) return false;
            } else {
                // For regular golfers and special needs, must be on a hole to count as "in use"
                if (
                    car?.Car?.HoleLocation === holeLocation.unknown &&
                    car?.Car?.CarType !== carType.marshal &&
                    car?.Car?.CarType !== carType.bevcart
                )
                    return false; // not on hole, not a marshal, not a beverage cart === not in use
            }
        } else {
            if (!isValidLocation(car?.Car?.Latitude, car?.Car?.Longitude)) {
                return false;
            }
        }

        return true; // in use!
    }

    function getCarsInUseByGolfers() {
        let result = [];

        allCarsData?.length !== 0 &&
            allCarsData?.map((car) => {
                // isCarInUse includes marshals and bevcarts (because it's meant to include all cars "being driven by somebody")
                // Since we just want golfers, filter out marshals and bevcarts, and Member cars if not Admin/Support
                // TODO: optionally include them since some courses have a problem with golfers switching to marshal mode?
                if (isCarInUse(car)) {
                    if (car?.Car?.CarType !== carType.marshal && car?.Car?.CarType !== carType.bevcart ) {
                        result.push(car);
                    }
                }
            });

        result.sort(function (a, b) {
            let result = compare(a.Course, b.Course);
            if (result === 0) result = compare(a.Hole, b.Hole);
            return result;
        });

        return result;
    }

    function pointInPolygon(
        point,
        polygon,
        longitudePropertyName,
        latitudePropertyName
    ) {
        // ray-casting algorithm based on
        // http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html

        let x = point[0],
            y = point[1];

        let inside = false;
        for (let i = 0, j = polygon?.length - 1; i < polygon?.length; j = i++) {
            let xi = polygon[i][longitudePropertyName],
                yi = polygon[i][latitudePropertyName];
            let xj = polygon[j][longitudePropertyName],
                yj = polygon[j][latitudePropertyName];

            let intersect =
                yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
            if (intersect) inside = !inside;
        }

        return inside;
    }

    function storeCurrentGeoFence() {
        let az = _.find(
            getCarPathActionZone && getCarPathActionZone,
            function (az) {
                return az?.IsGeofence === true;
            }
        );
        if (az) setGeoFence(az.AzVertexes);
    }

    function isCarInsideGeofence(car) {
        if (geoFence === null) return false;

        let point = [car?.Longitude, car?.Latitude];
        return pointInPolygon(point, geoFence, "Longitude", "Latitude");
    }

    function isCarOnCourse(car) {
        let point = [car?.Car?.Longitude, car?.Car?.Latitude];
        for (let i = 0; i < getSiteAreasState?.length; i++) {
            if (pointInPolygon(point, getSiteAreasState[i]?.Polygon, "Lon", "Lat")) {
                return true;
            }
        }

        for (let i = 0; i < getHoleAreasState?.length; i++) {
            if (pointInPolygon(point, getHoleAreasState[i]?.Polygon, "Lon", "Lat"))
                return true;
        }
        return false;
    }

    function canShowMemberCar(car) {

        if (siteSettingsData && siteSettingsData === null) return false;

        if (
            siteSettingsData &&
            siteSettingsData?.MemberCarTrackingLevel === memberCarTrackingLevel.Never
        )
            return false;

        if (
            siteSettingsData &&
            siteSettingsData?.MemberCarTrackingLevel === memberCarTrackingLevel.Always
        )
            return true;

        if (
            siteSettingsData &&
            siteSettingsData?.MemberCarTrackingLevel ===
            memberCarTrackingLevel.InsideGeoFence
        )
            return isCarInsideGeofence(car);

        if (
            siteSettingsData &&
            siteSettingsData?.MemberCarTrackingLevel ===
            memberCarTrackingLevel.OnCourseOrPlayingGolf
        ) {
            if (typeof car?.HolesPlayed !== "undefined" && car?.HolesPlayed !== 0)
                // Can be called to filter CarTrackInfo lists which don't have one
                return true;
            else {
                let inHoleExtents = isCarOnCourse(car);
                return inHoleExtents;
            }
        }

        return false;
    }

    function getCarFromId(gpsiCarId) {
        return (
            allCarsData &&
            allCarsData?.length !== 0 &&
            allCarsData?.find((car) => {
                return car?.Car?.GpsiCarId === gpsiCarId;
            })
        );
    }

    function getHoleLocationValue(car) {
        let holeWithLoc = car?.Car?.Hole;
        switch (car?.Car?.HoleLocation) {
            case holeLocation.betweenHoles:
                return holeWithLoc + 1; // not at next hole but finished with last
            case holeLocation.tee:
                return holeWithLoc + 0.25;
            case holeLocation.fairway:
                return holeWithLoc + 0.5;
            case holeLocation.green:
                return holeWithLoc + 0.75;
            default:
                return holeWithLoc;
        }
    }

    function getHistoryHoleLocationValue(car) {
        let holeWithLoc = car?.Hole;
        switch (car?.HoleLocation) {
            case holeLocation.betweenHoles:
                return holeWithLoc + 1; // not at next hole but finished with last
            case holeLocation.tee:
                return holeWithLoc + 0.25;
            case holeLocation.fairway:
                return holeWithLoc + 0.5;
            case holeLocation.green:
                return holeWithLoc + 0.75;
            default:
                return holeWithLoc;
        }
    }

    function updateNoCarsList(course) {
        if (course?.carData) {
            if (course?.carData?.length > 0) {
                if (noCarsList.indexOf(course?.Name) !== -1) {
                    let tempArr = noCarsList.filter((item) => item !== course?.Name);
                    setNoCarsList(tempArr);
                }
            } else {
                if (noCarsList.indexOf(course?.Name) === -1) {
                    noCarsList.push(course?.Name);
                }
            }
        } else {
            if (noCarsList.indexOf(course?.Name) === -1) {
                noCarsList.push(course?.Name);
            }
        }
    }

    function toggleCourseInPlay(course, isInPlay, siteSettingsCoursesArray) {
        let ssCourseIndex = _.findIndex(
            siteSettingsCoursesArray,
            function (sCourse) {
                return sCourse.Number === course.Number;
            }
        );

        if (siteSettingsCoursesArray && siteSettingsCoursesArray[ssCourseIndex]) {
            siteSettingsCoursesArray[ssCourseIndex].courseInPlay = isInPlay;
        }
    }

    function showData(course, siteSettingsCoursesArray) {
        let dataForChart = {};

        //size chart according to actual data for slow or fast pace, or default to 20, -20, or use prior when showing car history
        dataForChart.fastestPace = 0;
        dataForChart.slowestPace = 0;

        course?.carData?.forEach((data) => {
            if (data.pace > dataForChart.fastestPace) {
                dataForChart.fastestPace = data.pace;
            }
            if (data.pace < dataForChart.slowestPace) {
                dataForChart.slowestPace = data.pace;
            }
        });

        dataForChart.slowestPace = dataForChart.slowestPace > -20 ? -20 : dataForChart.slowestPace;
        dataForChart.fastestPace = dataForChart.fastestPace < 20 ? 20 : dataForChart.fastestPace;

        dataForChart.chartTitle =
            siteSettingsCoursesArray?.length === 1
                ? t("Live_Pace_by_Hole")
                : course?.Name + " " + t("Live_Pace_by_Hole");
        dataForChart.livePaceDivId = "#paceReportCourse" + course?.Number;
        dataForChart.HoleCount = course?.HoleCount;
        dataForChart.Number = course?.Number;
        dataForChart.carData = course?.carData;

        course.dataForChart = dataForChart;

        if (course?.carData?.length > 0) {
            chartData.push(dataForChart);

            getCourseData();

            toggleCourseInPlay(course, true, siteSettingsCoursesArray);
        } else {
            toggleCourseInPlay(course, false, siteSettingsCoursesArray);
        }
        updateNoCarsList(course);
    }

    function getCourseData() {
        const ids = chartData.map((data) => data?.Number);
        const filtered = chartData.filter(
            (data, index) =>
                !ids.includes(data?.Number, index + 1) &&
                !noCarsList.includes(data.chartTitle.split(" ")[0])
        );
        setChartData(filtered);
    }

    function conformCarData(arrayToAdd, courseToConform) {
        let data = [];

        arrayToAdd?.forEach((car, index) => {
            if (car?.Car?.Course === courseToConform) {
                if (!isMemberCar(car) || canShowMemberCar(car)) {
                    // TODO remove this change after figuring out why we have to set heartbeat for VDU 3.0 on verizon network
                    // to one minute.  This causes the LocationReasonForReport to often be REASON_FOR_REPORT_APN_FADE
                    // which filters out cars that should be in the Pace Report.  For now exempt VDU3 (Dev Type 4) cars from this filter
                    if (
                        car?.Car?.LocationReasonForReport !==
                        reportReasons.REASON_FOR_REPORT_UNDEFINED &&
                        car?.Car?.LocationReasonForReport !==
                        reportReasons.REASON_FOR_REPORT_VCC_FADE &&
                        (car?.Car?.LocationReasonForReport !==
                            reportReasons.REASON_FOR_REPORT_APN_FADE ||
                            car?.Car?.DevType === deviceType.VDU3 ||
                            car?.Car?.DevType === deviceType.VDU4)
                    ) {
                        let tempCar = getCarFromId(car?.Car?.GpsiCarId);
                        let holeWithLoc = getHoleLocationValue(car);
                        let datum = {
                            id: index + 1,
                            car: tempCar,
                            hole: holeWithLoc,
                            pace: car?.Car?.Pace * -1, //need to negate number so that ahead of pace follows logic (takes less time)
                            paceStatusColor: paceStatusBackColor(car?.Car?.PaceStatus),
                            paceStatusGroupName: paceStatusString(car?.Car?.PaceStatus),
                        };

                        data.push(datum);
                    }
                }
            }
        });

        return data;
    }

    function conformHistoryCarData(arrayToAdd, courseToConform) {
        let data = [];
        arrayToAdd?.forEach((car, index) => {
            if (car?.Course === courseToConform) {
                // if (!isMemberCar(car) || canShowMemberCar(car)) {
                // TODO remove this change after figuring out why we have to set heartbeat for VDU 3.0 on verizon network
                // to one minute.  This causes the LocationReasonForReport to often be REASON_FOR_REPORT_APN_FADE
                // which filters out cars that should be in the Pace Report.  For now exempt VDU3 (Dev Type 4) cars from this filter

                if (car?.LocationReasonForReport !== reportReasons.REASON_FOR_REPORT_UNDEFINED &&
                    car?.LocationReasonForReport !== reportReasons.REASON_FOR_REPORT_VCC_FADE &&
                    (car?.LocationReasonForReport !== reportReasons.REASON_FOR_REPORT_APN_FADE || car?.DevType === deviceType.VDU3 || car?.DevType === deviceType.VDU4)) {
                    let tempCar = getCarFromId(car?.GpsiCarId);
                    let holeWithLoc = getHistoryHoleLocationValue(car);
                    let datum = {
                        id: index + 1,
                        car: tempCar,
                        hole: holeWithLoc,
                        pace: car?.Pace * -1, //need to negate number so that ahead of pace follows logic (takes less time)
                        paceStatusColor: paceStatusBackColor(car?.PaceStatus),
                        paceStatusGroupName: paceStatusString(car?.PaceStatus),
                    };

                    data.push(datum);
                }
            }
        });

        return data;
    }

    function getData() {
        if (Object.keys(siteSettingsData).length > 0 && allCarsData?.length > 0) {
            let localCourseCarsInUseArray = courseCarsInUseArray;
            let localSiteSettingsCoursesArray = siteSettingsCourses;

            cars = getCarsInUseByGolfers();
            setFilteredCourse(getCoursesPlayingList());

            if (localSiteSettingsCoursesArray?.length === 0 || localSiteSettingsCoursesArray[0]?.siteId !== siteSettingsData?.Id) {
                localSiteSettingsCoursesArray = setSiteSettingsCoursesArray();
            }

            if (localCourseCarsInUseArray?.length === 0 || localCourseCarsInUseArray[0]?.siteId !== siteSettingsData?.Id) {
                localCourseCarsInUseArray = setCoursesInUseArray();
            }

            localCourseCarsInUseArray?.map((course, index) => {
                if (course.showingCarHistory) {
                    //use pace history already pulled
                    showData(course, localSiteSettingsCoursesArray);
                }
                else {
                    course.carData = conformCarData(cars, course?.Number);
                    showData(course, localSiteSettingsCoursesArray);
                }

                if (index === (localCourseCarsInUseArray.length - 1)) {
                    if (noCarsList.length === localCourseCarsInUseArray.length) {
                        setChartReadyToDraw(true); //no courses are playing, so it's true, there will just be no charts drawn
                    }
                }
            });

            setCourseCarsInUseArray(localCourseCarsInUseArray);
        } else if (Object.keys(siteSettingsData).length > 0) {
            updateNoCarsList(siteSettingsData?.Courses[0]);
        }

        paceLoading.set(false);
    }

    function getCarMatches(currentItem, course) {
        let xValue = currentItem?.value ? currentItem?.value?.x : currentItem?.hole;
        let yValue = currentItem?.value ? currentItem?.value?.y : currentItem?.pace;
        let carMatchesArray = [];
        for (let m = 0, length = chartData.length; m < length; m++) {
            for (
                let j = 0, innerLength = chartData[m]?.carData?.length;
                j < innerLength;
                j++
            ) {
                if (
                    xValue === chartData[m]?.carData[j]?.hole &&
                    yValue === chartData[m]?.carData[j]?.pace
                ) {
                    if (course) {
                        if (chartData[m].chartTitle === course?.chartTitle) {
                            let paceColor = chartData[m]?.carData[j]?.paceStatusColor;
                            let originalData = {
                                ...chartData[m]?.carData[j]?.car,
                                PaceColor: paceColor,
                            };
                            carMatchesArray.push(originalData);
                        }
                    } else {
                        let paceColor = chartData[m]?.carData[j]?.paceStatusColor;
                        let originalData = {
                            ...chartData[m]?.carData[j]?.car,
                            PaceColor: paceColor,
                        };
                        carMatchesArray.push(originalData);
                    }
                }
            }
        }
        return carMatchesArray;
    }

    function onMarkerClick(e, char) {
        let carMatches = getCarMatches(e, char);
        setCarDetailsTab(carMatches);
        setDetailTabData(e.dataItem);
    }

    const handleMsgToSelectedCarsClose = () => {
        isLoading.set(false);
        showMessageBoxForSingleCar.set(false);
    };

    async function showPaceHistory(data) {
        if (data?.Car?.GpsiCarId) {
            let courseIndex = _.findIndex(courseCarsInUseArray, function (tCourse) {
                return tCourse.Number === data?.Car?.Course;
            });

            if (courseCarsInUseArray[courseIndex]) {
                await getPaceHistory(courseCarsInUseArray[courseIndex].Number);
            } else {
                getData();
            }
        }
    }

    function tempShowPaceHistory(data) {
        if (data?.Car?.GpsiCarId) {
            let courseIndex = _.findIndex(courseCarsInUseArray, function (tCourse) {
                return tCourse.Number === data?.Car?.Course;
            });

            if (courseCarsInUseArray[courseIndex]) {
                tempGetPaceHistory(data?.Car?.Course);
            }
        }
    }

    function handleRefresh(gpsiCarId, index) {
        let hoursBack = 5;
        paceLoading.set(true);
        dispatch(
            COMMON_SERVICES.getSingleCarTrackServices(siteId.get(), gpsiCarId, hoursBack)
        ).then(() => {
            setTimeout(() => {
                paceLoading.set(false);
            }, 1000);
            showPaceHistory(carDetailsTab[index]);
        });
    }

    function sendMsg(gpsiCarId) {
        dispatch(
            COMMON_SERVICES.sendMessagesServices(
                msgInput,
                0,
                gpsiCarId.toString(),
                siteId.get()
            )
        );
        setMsgInput("");
    }

    function tagCar(tagCarNumbers) {
        let temp = JSON.parse(JSON.stringify(taggedCarsSaverGlobalState.get()));
        let found = temp.findIndex((item) => item === tagCarNumbers);

        if (tagCarNumber.get().length === 0) {
            tagCarNumber.set((tasks) => [...tasks, tagCarNumbers]);
        } else {
            const exists = tagCarNumber.get().find((item) => item === tagCarNumbers);
            if (exists) {
                tagCarNumber.set((tasks) =>
                    tasks.filter((task) => task !== tagCarNumbers)
                );
            } else {
                tagCarNumber.set((tasks) => [...tasks, tagCarNumbers]);
            }
        }

        const localStorageData = JSON.parse(localStorage.getItem("taggedCarsData"));

        const showTaggedCarArrayExist = showTaggedCarArray
            .get()
            .find((item) => item === tagCarNumbers);
        if (showTaggedCarArrayExist) {
            showTaggedCarArray.set((tasks) =>
                tasks.filter((task) => task !== tagCarNumbers)
            );
            highlightTagCar.set(false);
        } else {
            showTaggedCarArray.set((tasks) => [...tasks, tagCarNumbers]);
            highlightTagCar.set(true);
        }
        const taggedCarsSaverGlobalStateExist = taggedCarsSaverGlobalState
            .get()
            .find((item) => item === tagCarNumbers);
        if (taggedCarsSaverGlobalStateExist) {
            taggedCarsSaverGlobalState.set((tasks) =>
                tasks.filter((task) => task !== tagCarNumbers)
            );
            taggedCarsDisplayerGlobalState.set(false);
            highlightTagCar.set(false);
            findCars.set(false);
            paceFindCar.set(false);
        } else {
            taggedCarsSaverGlobalState.set((tasks) => [...tasks, tagCarNumbers]);
            taggedCarsDisplayerGlobalState.set(true);
            highlightTagCar.set(true);
            paceFindCar.set(true);
        }

        let tagCarStringfy = JSON.stringify(taggedCarsSaverGlobalState.get());
        let tagCarParse = JSON.parse(tagCarStringfy);
        showTaggedCarArray.set(tagCarParse);

        if (localStorageData) {
            localStorage.setItem(
                "taggedCarsData",
                JSON.stringify({
                    findCars: true,
                    taggedCarsDisplayerGlobalState: taggedCarsDisplayerGlobalState.get(),
                    tagCarsDataMap: taggedCarsSaverGlobalState.get(),
                    tagCarsDataFilters: showTaggedCarArray.get(),
                })
            );
        } else {
            localStorage.setItem(
                "taggedCarsData",
                JSON.stringify({
                    findCars: true,
                    taggedCarsDisplayerGlobalState: taggedCarsDisplayerGlobalState.get(),
                    tagCarsDataMap: taggedCarsSaverGlobalState.get(),
                    tagCarsDataFilters: showTaggedCarArray.get(),
                })
            );
        }

        if (found === -1) {
            subNavDataState.set("MAP");
            sideDrawerActiveTabState.set(1);
            navigate("/map");
        }
        setRefreshChart(true);
        setTimeout(() => setRefreshChart(false), 2000);
    }

    const handleChartRefresh = (chartOptions, themeOptions, chartInstance) => {
        if (refreshChart) {
            chartInstance.setOptions(chartOptions, themeOptions);
        }
    };

    function getMarginBasedOnHoleCount(holeCount, getChartDimensions) {
        var chartMargin = 0;
        chartMargin =
            holeCount != 0 ? getChartDimensions.chartWidth / holeCount : 0;
        return parseInt(chartMargin);
    }

    return (
        <>
            {paceLoading.get() || disabledStatus ? (
                <>
                    <Loader />
                </>
            ) : (
                <>
                    <CurrentPageContainer>
                        <Wrapper ref={containerW}>
                            <div>
                                <HeadingWrapper>
                                    <h2>{t("Live_Pace_by_Hole")}</h2>
                                </HeadingWrapper>
                                <BodyWrapper ref={divRef}>
                                    {siteSettingsData && chartReadyToDraw && chartData?.length !== 0 ? (
                                        chartData?.map((char, index) => {
                                            return (
                                                <Chart
                                                    key={index}
                                                    onRefresh={handleChartRefresh}
                                                    onSeriesClick={(e) => {
                                                        setTimeout(() => {
                                                            setDetailTab(true);
                                                            onMarkerClick(e, char);
                                                            setActiveHistory({
                                                                ...activeHistory,
                                                                [e.dataItem.car.Car.CarNumber]: activeHistory[
                                                                    e.dataItem.car.Car.CarNumber
                                                                ]
                                                                    ? activeHistory[e.dataItem.car.Car.CarNumber]
                                                                    : false,
                                                            });
                                                        }, 300);
                                                    }}
                                                    onDoubleClick={(e) => e.preventDefault()}
                                                    transitions={false}
                                                >
                                                    <ChartPanes>
                                                        <ChartPane clip={false} />
                                                    </ChartPanes>
                                                    <ChartTooltip />
                                                    <ChartTitle text={char?.chartTitle} color="black" />
                                                    <ChartSeries>
                                                        <ChartSeriesItem
                                                            type="scatter"
                                                            data={char?.carData}
                                                            xField="hole"
                                                            yField="pace"
                                                            markers={{
                                                                visible: true,
                                                                size: (e) => {
                                                                    // Calculate the marker size based on the text length
                                                                    const text =
                                                                        e?.dataItem?.car?.Car?.CarNumber.toString();
                                                                    const textSize = text.length * 8; // Adjust the size factor based on your preference
                                                                    return textSize < 21 ? 21 : textSize; // Set a minimum size of 30 to ensure visibility
                                                                },
                                                                color: (e) => {
                                                                    var carMatches = getCarMatches(e); //see if there is more than one car marker here
                                                                    var anyCarsTagged = "";
                                                                    carMatches?.forEach((car, index) => {
                                                                        let found = historyCarNo.find(
                                                                            (i) => i === car?.Car?.CarNumber
                                                                        );

                                                                        anyCarsTagged = found
                                                                            ? carMatches[index]?.PaceColor
                                                                            : "#000";
                                                                    });

                                                                    return anyCarsTagged;
                                                                },
                                                                background: (e) => {
                                                                    var carMatches = getCarMatches(e); //see if there is more than one car marker here

                                                                    var anyCarsTagged = "";

                                                                    carMatches?.forEach((car, index) => {
                                                                        let found = historyCarNo.find(
                                                                            (i) =>
                                                                                i ===
                                                                                char.carData[0]?.car?.Car?.CarNumber
                                                                        );
                                                                        if (found) {
                                                                            anyCarsTagged = "#fff";
                                                                        } else {
                                                                            anyCarsTagged =
                                                                                carMatches[index]?.PaceColor;
                                                                        }
                                                                    });

                                                                    return anyCarsTagged;
                                                                },
                                                                type: function (e) {
                                                                    if (isMemberCar(e?.dataItem?.car))
                                                                        return "square"; // make markers square for member cars
                                                                    return "circle";
                                                                },
                                                                border: {
                                                                    width: (e) => {
                                                                        var carMatches = getCarMatches(e); //see if there is more than one car marker here
                                                                        var anyCarsTagged = false;

                                                                        carMatches?.forEach((car) => {
                                                                            let found =
                                                                                taggedCarsSaverGlobalState.get() !==
                                                                                undefined &&
                                                                                taggedCarsSaverGlobalState
                                                                                    .get()
                                                                                    .find(
                                                                                        (i) => i === car?.Car?.CarNumber
                                                                                    );

                                                                            let foundHistoryCarNo = historyCarNo.find(
                                                                                (i) => i === car?.Car?.CarNumber
                                                                            );
                                                                            if (foundHistoryCarNo || !found) {
                                                                                anyCarsTagged = true;
                                                                            }
                                                                        });
                                                                        var borderWidth = anyCarsTagged ? 1 : 5;
                                                                        return borderWidth;
                                                                    },
                                                                    color: (e) => {
                                                                        var carMatches = getCarMatches(e); //see if there is more than one car marker here
                                                                        var anyCarsTagged = "";

                                                                        carMatches?.forEach((car, index) => {
                                                                            if (
                                                                                historyCarNo.includes(
                                                                                    char.carData[0]?.car?.Car?.CarNumber
                                                                                )
                                                                            ) {
                                                                                anyCarsTagged =
                                                                                    carMatches[index]?.PaceColor;
                                                                            }
                                                                        });

                                                                        return anyCarsTagged;
                                                                    },
                                                                },
                                                            }}
                                                            highlight={{
                                                                visible: false,
                                                            }}
                                                            labels={{
                                                                visible: true,
                                                                position: "center",
                                                                align: "center",
                                                                background: "transparent",
                                                                cursor: "pointer",
                                                                template: function (e) {
                                                                    let carMatches = getCarMatches(e, char);
                                                                    let labelsBasedOnMultiples;

                                                                    labelsBasedOnMultiples =
                                                                        carMatches?.length > 1
                                                                            ? "+"
                                                                            : e?.dataItem?.car?.Car?.CarNumber.toString();
                                                                    return labelsBasedOnMultiples;
                                                                },
                                                                font: function (e) {
                                                                    let fontBasedOnMultiplesOrCarNumber =
                                                                        e?.dataItem?.car?.Car?.CarNumber >= 100
                                                                            ? "10px Arial,Helvetica,sans-serif"
                                                                            : "14px Arial,Helvetica,sans-serif";
                                                                    return fontBasedOnMultiplesOrCarNumber;
                                                                },
                                                                color: function (e) {
                                                                    var carMatches = getCarMatches(e); //see if there is more than one car marker here
                                                                    var anyCarsTagged = "";
                                                                    carMatches?.forEach((car, index) => {
                                                                        if (
                                                                            historyCarNo.includes(
                                                                                char.carData[0]?.car?.Car?.CarNumber
                                                                            )
                                                                        ) {
                                                                            anyCarsTagged =
                                                                                carMatches[index]?.PaceColor;
                                                                        } else {
                                                                            anyCarsTagged = "#fff";
                                                                        }
                                                                    });

                                                                    return anyCarsTagged;
                                                                },

                                                                padding: {
                                                                    top: 4,
                                                                },
                                                            }}
                                                            tooltip={{
                                                                visible: !isMobile,
                                                                background: "white",
                                                                border: {color: "#000", width: 2},
                                                                render: (e) => {
                                                                    let carMatches = getCarMatches(e.point, char);
                                                                    return (
                                                                        <>
                                                                            {carMatches?.length !== 0 ? (
                                                                                <>
                                                                                    {carMatches?.map((car, index) => {
                                                                                        return (
                                                                                            <div key={index}>
                                                                                                <span>
                                                                                                    {t("Cars")}:{" "}
                                                                                                    {car?.Car?.CarNumber.toString()}
                                                                                                </span>
                                                                                                <br />
                                                                                                <span>
                                                                                                    {moment.utc(car?.Car?.LastLocationUpdateInUtc).utcOffset(-siteSettingsData?.TimeZoneOffset).format("DD-MMM-YYYY, h:mm a").toString()}
                                                                                                </span>

                                                                                                <br />
                                                                                                <span>
                                                                                                    {t("Hole")} : {car?.Car?.Hole}
                                                                                                </span>
                                                                                                <br />
                                                                                                <span>
                                                                                                    {t("Report_Reason")} :{" "}
                                                                                                    {reasonForReportString(car?.Car?.LocationReasonForReport)}
                                                                                                </span>
                                                                                                <br />
                                                                                                <span>
                                                                                                    {t("GPRS_Signal")} :{" "}
                                                                                                    {
                                                                                                        car?.Car?.LocationGprsSignalStrength
                                                                                                    }
                                                                                                </span>
                                                                                                {car?.Car?.PlayerName1 !==
                                                                                                    null ? (
                                                                                                    <>
                                                                                                        <br />
                                                                                                        <span>
                                                                                                            Player Name 1 :{" "}
                                                                                                            {car?.Car?.PlayerName1}
                                                                                                        </span>
                                                                                                    </>
                                                                                                ) : (
                                                                                                    <></>
                                                                                                )}
                                                                                                {car?.Car?.PlayerName2 !==
                                                                                                    null ? (
                                                                                                    <>
                                                                                                        <br />
                                                                                                        <span>
                                                                                                            Player Name 2 :{" "}
                                                                                                            {car?.Car?.PlayerName2}
                                                                                                        </span>
                                                                                                    </>
                                                                                                ) : (
                                                                                                    <></>
                                                                                                )}

                                                                                                <br />
                                                                                                <span>
                                                                                                    {t("Sequence")} :{" "}
                                                                                                    {
                                                                                                        car?.Car
                                                                                                            ?.LocationSequenceNumber
                                                                                                    }
                                                                                                </span>
                                                                                                <br />
                                                                                                <span>
                                                                                                    {getPaceString(car?.Car?.Pace, car?.Car?.HolesPlayed)}
                                                                                                </span>
                                                                                                <br />
                                                                                                <br />
                                                                                            </div>
                                                                                        );
                                                                                    })}
                                                                                </>
                                                                            ) : (
                                                                                <>{t("No_data")}</>
                                                                            )}
                                                                        </>
                                                                    );
                                                                },
                                                            }}
                                                        />
                                                    </ChartSeries>

                                                    <ChartXAxis>
                                                        <ChartXAxisItem
                                                            title={{
                                                                text: t("Hole"),
                                                            }}
                                                            min={1}
                                                            max={chartHoleCountData !== null ? chartHoleCountData : chartData[0]?.HoleCount}
                                                            majorUnit={1}
                                                            labels={{
                                                                margin: {
                                                                    left: getMarginBasedOnHoleCount(
                                                                        chartHoleCountData !== null
                                                                            ? chartHoleCountData
                                                                            : chartData[0]?.HoleCount,
                                                                        getChartDimensions
                                                                    ),
                                                                },
                                                                content: (e) => {
                                                                    return e.value !== chartHoleCountData
                                                                        ? e.value
                                                                        : "";
                                                                },
                                                            }}
                                                        />
                                                    </ChartXAxis>
                                                    <ChartYAxis>
                                                        <ChartYAxisItem
                                                            axisCrossingValue={[char?.slowestPace, 1]}
                                                            min={char?.slowestPace}
                                                            max={char?.fastestPace}
                                                            title={{
                                                                text: t("Pace_in_Minutes"),
                                                            }}
                                                            plotBands={[
                                                                {
                                                                    from: warningPlotBand,
                                                                    to: criticalPlotBand,
                                                                    color: "orange",
                                                                    opacity: 0.08,
                                                                },
                                                                {
                                                                    from: criticalPlotBand,
                                                                    to: char?.fastestPace,
                                                                    color: "red",
                                                                    opacity: 0.08,
                                                                },
                                                                {
                                                                    from: -0.07,
                                                                    to: 0.07,
                                                                    color: "black",
                                                                    opacity: 1,
                                                                },
                                                                {
                                                                    from: warningPlotBand,
                                                                    to: char?.slowestPace,
                                                                    color: "green",
                                                                    opacity: 0.1,
                                                                },
                                                                {
                                                                    from: criticalPlotBand + 0.06,
                                                                    to: criticalPlotBand - 0.06,
                                                                    color: "red",
                                                                    opacity: 1,
                                                                },
                                                                {
                                                                    from: warningPlotBand + 0.06,
                                                                    to: warningPlotBand - 0.06,
                                                                    color: "orange",
                                                                    opacity: 1,
                                                                },
                                                            ]}
                                                        />
                                                    </ChartYAxis>
                                                    <ChartLegend visible="true" />
                                                </Chart>
                                            );
                                        })
                                    ) : (
                                        <></>
                                    )}
                                    <div className="playing-cars">
                                        {siteSettingsData?.Courses?.length !== 0 &&
                                            noCarsList.length !== 0 ? (
                                            <>
                                                {siteSettingsData?.Courses?.map((li) => {
                                                    return (
                                                        <span key={uuid()}>
                                                            {noCarsList.includes(li?.Name)
                                                                ? t("No_cars_playing") + " " + li?.Name
                                                                : ""}
                                                        </span>
                                                    );
                                                })}
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </BodyWrapper>
                            </div>
                            {detailTab && (
                                <DetailSideTab ref={detailW}>
                                    <div className="heading">
                                        <h2>{t("Detail")}</h2>
                                        <CloseIcon
                                            className="close-icon"
                                            onClick={() => {
                                                setDetailTab(false);
                                                setRefreshChart(true);
                                                setTimeout(() => setRefreshChart(false), 2000);
                                            }}
                                        />
                                    </div>
                                    <CardWrapper>
                                        <Card>
                                            {carDetailsTab && carDetailsTab.length !== 0 ? (
                                                <>
                                                    {carDetailsTab?.map((car, index) => {
                                                        return (
                                                            <div key={index}>
                                                                <h2 className="heading">
                                                                    {t("Car_Number")} {car?.Car?.CarNumber}{" "}
                                                                </h2>
                                                                <p className="date-hole-number">
                                                                    {moment
                                                                        .utc(car?.Car?.LastLocationUpdateInUtc)
                                                                        .utcOffset(
                                                                            -siteSettingsData?.TimeZoneOffset
                                                                        )
                                                                        .format("DD-MMM-YYYY, h:mm a")
                                                                        .toString()}
                                                                    , {t("Hole")} : {car?.Car?.Hole}
                                                                </p>
                                                                <p className="behind-time">
                                                                    {getPaceString(car?.Car?.Pace, car?.Car?.HolesPlayed)}
                                                                </p>
                                                                <div className="action-btn">
                                                                    <CircleBtn
                                                                        className={
                                                                            tempIndex.includes(index) ? "active" : ""
                                                                        }
                                                                        onClick={() => {
                                                                            setTabIndex(index);
                                                                            setTempIndex(
                                                                                tempIndex.length === 0
                                                                                    ? [...tempIndex, index]
                                                                                    : tempIndex.filter(
                                                                                        (item) => item !== index
                                                                                    )
                                                                            );
                                                                        }}
                                                                    >
                                                                        {t("Messages")}
                                                                    </CircleBtn>
                                                                    <CircleBtn
                                                                        className={open ? "active" : ""}
                                                                        onClick={() => {
                                                                            setTabIndex(index);
                                                                            handleOpen();
                                                                            storeFleetTagCarData.set(car?.Car);
                                                                            let getGpsiCarId = car?.Car?.GpsiCarId;
                                                                            gpsCardIdStateData.set(
                                                                                car?.Car?.GpsiCarId
                                                                            );
                                                                            let getCarData = allCarsData;
                                                                            let filterCar = getCarData.filter(
                                                                                (item) =>
                                                                                    item?.Car?.GpsiCarId === getGpsiCarId
                                                                            );
                                                                            setCurrentCarPorperty(filterCar[0]);
                                                                        }}
                                                                    >
                                                                        {t("Properties")}
                                                                    </CircleBtn>
                                                                    <CircleBtn
                                                                        className={
                                                                            activeHistory[car?.Car?.CarNumber]
                                                                                ? "active"
                                                                                : ""
                                                                        }
                                                                        onClick={(e) => {
                                                                            setHistoryTempIndex(
                                                                                historyTempIndex.length === 0
                                                                                    ? [...historyTempIndex, index]
                                                                                    : historyTempIndex.filter(
                                                                                        (item) => item !== index
                                                                                    )
                                                                            );
                                                                            if (!activeHistory[car?.Car?.CarNumber]) {
                                                                                if (!historyCarNo?.length) {
                                                                                    setPrevChartData(chartData);
                                                                                }

                                                                                setActiveHistory({
                                                                                    ...activeHistory,
                                                                                    [car?.Car?.CarNumber]: true,
                                                                                });

                                                                                setDisabledStatus(true);
                                                                                historyCarNo.push(car?.Car?.CarNumber);
                                                                                let hoursBack = 5;
                                                                                dispatch(
                                                                                    COMMON_SERVICES.getSingleCarTrackServices(
                                                                                        siteId.get(),
                                                                                        car.Car?.GpsiCarId,
                                                                                        hoursBack
                                                                                    )
                                                                                );
                                                                            } else {
                                                                                setActiveHistory({
                                                                                    ...activeHistory,
                                                                                    [car?.Car?.CarNumber]: false,
                                                                                });

                                                                                setHistoryCarNo([
                                                                                    ...historyCarNo.filter(
                                                                                        (i) => i !== car?.Car?.CarNumber
                                                                                    ),
                                                                                ]);

                                                                                let result = chartData.map((item) => {
                                                                                    if (
                                                                                        item.Number === car?.Car?.Course
                                                                                    ) {
                                                                                        let tempData = prevChartData.filter(
                                                                                            (data) =>
                                                                                                data.Number === car?.Car?.Course
                                                                                        );
                                                                                        return tempData[0];
                                                                                    } else {
                                                                                        return item;
                                                                                    }
                                                                                });

                                                                                setChartData(result);
                                                                                setRefreshChart(true);
                                                                                setTimeout(
                                                                                    () => setRefreshChart(false),
                                                                                    2000
                                                                                );
                                                                            }
                                                                        }}
                                                                    >
                                                                        {t("History")}
                                                                    </CircleBtn>

                                                                    {activeHistory[car?.Car?.CarNumber] && (
                                                                        <CircleBtn
                                                                            onClick={() => handleRefresh(car?.Car?.GpsiCarId, index)}
                                                                        >
                                                                            {t("Refresh")}
                                                                        </CircleBtn>
                                                                    )}
                                                                </div>

                                                                <CircleBtn
                                                                    style={{
                                                                        background:
                                                                            taggedCarsSaverGlobalState.get() !==
                                                                                undefined &&
                                                                                taggedCarsSaverGlobalState
                                                                                    .get()
                                                                                    .find(
                                                                                        (i) => i === car?.Car?.CarNumber
                                                                                    ) === car?.Car?.CarNumber
                                                                                ? "var(--theme-background)"
                                                                                : "",
                                                                        color:
                                                                            taggedCarsSaverGlobalState.get() !==
                                                                                undefined &&
                                                                                taggedCarsSaverGlobalState
                                                                                    .get()
                                                                                    .find(
                                                                                        (i) => i === car?.Car?.CarNumber
                                                                                    ) === car?.Car?.CarNumber
                                                                                ? "white"
                                                                                : "black",
                                                                        width: '100%',
                                                                        marginTop: '10px'
                                                                    }}
                                                                    onClick={() =>
                                                                        tagCar(car?.Car?.CarNumber)
                                                                    }
                                                                >
                                                                    {t("Find_car")}
                                                                </CircleBtn>

                                                                {tempIndex.includes(index) ? (
                                                                    <>
                                                                        <NotificationTabsContainer>
                                                                            <TabContext value={value}>
                                                                                <Box
                                                                                    sx={{
                                                                                        borderBottom: 1,
                                                                                        borderColor: "divider",
                                                                                    }}
                                                                                >
                                                                                    <TabList
                                                                                        onChange={handleChange}
                                                                                        aria-label="tabs"
                                                                                    >
                                                                                        <Tab
                                                                                            label={
                                                                                                <span>
                                                                                                    {t("Car_Number")}&nbsp;
                                                                                                    {
                                                                                                        carDetailsTab[tabIndex]?.Car?.CarNumber
                                                                                                    }
                                                                                                </span>
                                                                                            }
                                                                                            value="1"
                                                                                        />
                                                                                    </TabList>
                                                                                </Box>
                                                                                <TabPanel value="1">
                                                                                    <textarea
                                                                                        maxLength={182}
                                                                                        className="text-area"
                                                                                        id="w3review"
                                                                                        name="w3review"
                                                                                        rows="4"
                                                                                        cols="50"
                                                                                        placeholder={t("Type_your_message")}
                                                                                        value={msgInput}
                                                                                        onChange={(e) => {
                                                                                            setMsgInput(e.target.value);
                                                                                        }}
                                                                                    ></textarea>
                                                                                    {msgInput !== "" ? (
                                                                                        <>
                                                                                            <CircleBtn
                                                                                                className="send-btn"
                                                                                                onClick={() =>
                                                                                                    sendMsg(car?.Car?.GpsiCarId)
                                                                                                }
                                                                                            >
                                                                                                {t("Send")}
                                                                                            </CircleBtn>
                                                                                        </>
                                                                                    ) : (
                                                                                        <></>
                                                                                    )}
                                                                                </TabPanel>
                                                                            </TabContext>
                                                                        </NotificationTabsContainer>
                                                                    </>
                                                                ) : (
                                                                    <></>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </>
                                            ) : (
                                                <>{t("No_data")}</>
                                            )}

                                            <Modal
                                                open={open}
                                                onClose={handleCarDetailClose}
                                                aria-labelledby="modal-modal-title"
                                                aria-describedby="modal-modal-description"
                                            >
                                                <Box sx={carDetailStyle}>
                                                    <CarDetails
                                                        carInformation={currentCarProperty}
                                                        handleClick={handleCarDetailClose}
                                                        paceString={paceString}
                                                    />
                                                </Box>
                                            </Modal>
                                            <Modal
                                                open={isLoading.get()}
                                                onClose={handleMsgToSelectedCarsClose}
                                                aria-labelledby="modal-modal-title"
                                                aria-describedby="modal-modal-description"
                                            >
                                                <Box sx={msgToCarsStyle}>
                                                    <MsgToSelectedCarsCmp cancelClick={handleMsgToSelectedCarsClose} />
                                                </Box>
                                            </Modal>
                                        </Card>
                                    </CardWrapper>
                                </DetailSideTab>
                            )}
                        </Wrapper>
                    </CurrentPageContainer>
                </>
            )}
        </>
    );
});

export default CurrentPage;
